import React from 'react'

function Blob() {
    return (
        <>
            <svg width="230" height="223" viewBox="0 0 230 223" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_310_569)">
                    <path d="M18.5155 129.634C-6.64607 81.7139 -2.16721 44.4884 46.7304 18.8134C95.628 -6.86163 161.191 10.9395 186.353 58.8592C211.514 106.779 204.966 163.727 156.069 189.402C107.171 215.077 43.677 177.553 18.5155 129.634Z" fill="url(#paint0_linear_310_569)" shape-rendering="crispEdges" />
                </g>
                <defs>
                    <filter id="filter0_d_310_569" x="0.477112" y="0.0718689" width="229.244" height="222.664" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dx="13" dy="9" />
                        <feGaussianBlur stdDeviation="8" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_310_569" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_310_569" result="shape" />
                    </filter>
                    <linearGradient id="paint0_linear_310_569" x1="178.567" y1="162.341" x2="59.3473" y2="12.1886" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#5779F1" />
                        <stop offset="1" stop-color="#549BC4" stop-opacity="0.53" />
                    </linearGradient>
                </defs>
            </svg>
        </>
    )
}

export default Blob